import { useGetInfoUserQuery, useGetProfileQuery } from 'redux/Api/profileApi/ProfileApi';
import { useEffect, useRef } from 'react';

const COUNTER_ID = Number(process.env.REACT_APP_COUNTER_ID);

const isWorksupportRole = () =>
  (localStorage.getItem('role') || '').toLowerCase() === 'worksupport';

const useYandexMetricaInit = () => {
  const token = localStorage.getItem('token');
  const showCompanySelect = localStorage.getItem('showCompanySelect');
  const isAuth = !!token && !showCompanySelect;

  const { data: userData } = useGetInfoUserQuery(undefined, {
    skip: !isAuth || isWorksupportRole(),
  });

  const { data } = useGetProfileQuery(undefined, {
    skip: !isAuth || isWorksupportRole(),
  });

  const prevUserKey = useRef<string | null>(null);

  useEffect(() => {
    if (isNaN(COUNTER_ID) || COUNTER_ID === 0) return;
    if (isWorksupportRole()) return;
    if (!isAuth || !userData?.id || !data?.id) return;

    const currentUserKey = `${data.id}_${userData.id}`;

    if (prevUserKey.current === currentUserKey) return;

    prevUserKey.current = currentUserKey;

    const sendToMetrica = () => {
      if (typeof window.ym === 'function') {
        window.ym(COUNTER_ID, 'setUserID', currentUserKey);
        window.ym(COUNTER_ID, 'params', {
          customer_id: data.id,
          user_id: userData.id,
        });
      }
    };

    if (typeof window.ym === 'function') {
      sendToMetrica();
    } else {
      const checkYm = setInterval(() => {
        if (typeof window.ym === 'function') {
          clearInterval(checkYm);
          sendToMetrica();
        }
      }, 100);
      setTimeout(() => clearInterval(checkYm), 5000);
    }
  }, [isAuth, userData?.id, data?.id]);
};

export default useYandexMetricaInit;
